import { FunctionFactory } from "survey-core";
import { Gender } from "./gender";
import { loc } from "../i18n/survey";

enum Physiology {
  Male = "Male Physiology",
  Female = "Female Physiology",
}


const physiologyQuestion = {
  name: "physiology",
  title: loc("quiz.physiology.title"),
  description: loc("quiz.physiology.description"),
  descriptionLocation: 'underTitle',
  type: "radiogroup",
  choices: [
    { value: Physiology.Male, text: loc("quiz.physiology.choices.male") },
    { value: Physiology.Female, text: loc("quiz.physiology.choices.female") },
  ],
  isRequired: true,
  visibleIf: `{gender} == "${Gender.NonBinary}"`,
};

// const genderNounExpression = {
//   name: "genderNoun",
//   expression: "renderGender({gender})",
// };

// function renderGender(params: any[]): string {
//   if (params === undefined || params === null) return "";
//   return (params[0] as Gender) === Gender.Female ? "women" : "men";
// }

//FunctionFactory.Instance.register("renderGender", renderGender);

export { Physiology, physiologyQuestion };
